import { Stack, Typography } from '@mui/material';

import { TemplateGallery } from '@/components/templates/TemplateGallery';
import type { SiteTemplate } from '@/lib/templates/types';
import type { UnitType } from '@/types/database';

interface TemplateStepProps {
  unitType: UnitType | null;
  unitName: string;
  unitIdentifier: string;
  onSelectTemplate: (template: SiteTemplate) => void;
}

// Spec section 4, Step 3. Reuses the same TemplateGallery Studio's empty
// state already used — selecting here just stores the choice (applied at
// the Review & Publish step, once brand/privacy are picked too) rather
// than applying immediately the way today's inline gallery does.
export function TemplateStep({ unitType, unitName, unitIdentifier, onSelectTemplate }: TemplateStepProps) {
  return (
    <Stack spacing={2.5}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Choose a starting point
      </Typography>
      <TemplateGallery
        unitType={unitType}
        unitName={unitName}
        unitIdentifier={unitIdentifier}
        applying={false}
        onSelectTemplate={onSelectTemplate}
      />
    </Stack>
  );
}
